import React from 'react';

import { isValidRecipient } from '../../../utils';

// TODO either move to global utils or create local utils folder
export const checkForRecipientError = (
  recepientAddress: string,
  safeAddress: string | undefined,
  setRecipientAddressErrorMessage: (value: React.SetStateAction<string>) => void
) => {
  if (recepientAddress.endsWith('.stxs')) {
    setRecipientAddressErrorMessage('Invalid STXS name');

    return true;
  } else if (recepientAddress.includes('.')) {
    if (!isValidRecipient(recepientAddress)) {
      setRecipientAddressErrorMessage('Invalid BNS name');

      return true;
    }
  }
  if (!isValidRecipient(recepientAddress) && recepientAddress.length > 0) {
    setRecipientAddressErrorMessage('Invalid address');

    return true;
  }
  if (recepientAddress === safeAddress) {
    setRecipientAddressErrorMessage('Current vault address');

    return true;
  }

  return false;
};
